import { Component } from "react";
import { Link } from "react-router-dom";
import { reportError } from "../../lib/errorReporter.js";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info);
    reportError({ type: "reactError", error, componentStack: info.componentStack });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4 text-center px-4">
          <h2 className="text-xl font-semibold text-foreground">Something went wrong</h2>
          <p className="text-muted-foreground text-sm max-w-sm">
            An unexpected error occurred. Try refreshing, or return to the dashboard.
          </p>
          <div className="flex gap-3">
            <button
              onClick={() => this.setState({ hasError: false })}
              className="text-sm underline text-muted-foreground hover:text-foreground"
            >
              Try again
            </button>
            <Link to="/dashboard" className="text-sm underline text-primary hover:opacity-80">
              Go to Dashboard
            </Link>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
